import BirthdayGif from './90BirthdayGif.gif';
import React from 'react';
import './Loading.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const Loading = () => (
  <div className="loading overlay">
    <div>
      <img src={BirthdayGif} alt="Loading..." className="loading-gif" />
    </div>
    {/* <FontAwesomeIcon icon={faSpinner} size="lg" spin inverse /> */}
  </div>
);

export default Loading;
